import {
    ADDUPDATE_USERDETAILS_SUCCESS,
    ADDUPDATE_USERDETAILS_FAILED,
    RESET_ADDUPDATE_USERDETAILS,
    LOADING_ADDUPDATE_USERDETAILS,
    ADDUPDATE_USERDETAILS_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDUPDATE_USERDETAILS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDUPDATE_USERDETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDUPDATE_USERDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case ADDUPDATE_USERDETAILS_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDUPDATE_USERDETAILS:
            return (state = initialState);
        default:
            return state;
    }
};
